import { render, staticRenderFns } from "./mealStatistics.vue?vue&type=template&id=28f1ddd1&scoped=true"
import script from "./mealStatistics.vue?vue&type=script&lang=js"
export * from "./mealStatistics.vue?vue&type=script&lang=js"
import style0 from "./mealStatistics.vue?vue&type=style&index=0&id=28f1ddd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1ddd1",
  null
  
)

export default component.exports